import { AllowanceConsultationEffects } from './allowance-consultation.effects';
import { AllowanceRecommendationEffects } from './allowance-recommendation.effects';
import { AllowanceShareEffects } from './allowance-share.effects';
import { AllowanceStepsEffects } from './allowance-steps.effects';
import { AllowanceVetSourceEffects } from './allowance-vetsource.effects';

export const AllowanceEffects = [
  AllowanceConsultationEffects,
  AllowanceRecommendationEffects,
  AllowanceShareEffects,
  AllowanceStepsEffects,
  AllowanceVetSourceEffects,
];
